import Swiper from 'swiper';
import { breakpoints, measurements } from '../conf';

export const options = {
  slidesPerView: 1.4,
  spaceBetween: measurements.mobileGutterWidth,
  slidesOffsetBefore: measurements.pageMarginXs,
  slidesOffsetAfter: measurements.pageMarginXs,
  navigation: {
    nextEl: '[data-image-swiper-next]',
    prevEl: '[data-image-swiper-prev]',
  },
  scrollbar: {
    el: '[data-image-swiper-scrollbar]',
    hide: false,
  },
  breakpoints: {
    [breakpoints.md]: {
      slidesPerView: 2,
      spaceBetween: measurements.gutterWidth,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
    [breakpoints.lg]: {
      slidesPerView: 3,
      spaceBetween: measurements.gutterWidth,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
  },
};

export default () => {
  const els = document.querySelectorAll('[data-image-swiper]');

  if (els.length) {
    els.forEach((el) => {
      const parentEl = el.parentElement;
      const attrOptions = el.dataset.imageSwiper ? JSON.parse(el.dataset.imageSwiper) : {};

      options.navigation.nextEl = parentEl.querySelectorAll('[data-image-swiper-next]');
      options.navigation.prevEl = parentEl.querySelectorAll('[data-image-swiper-prev]');
      options.scrollbar.el = parentEl.querySelector('[data-image-swiper-scrollbar]');

      const swiper = new Swiper(el, { ...options, ...attrOptions });

      return swiper;
    });
  }
};
